var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditOutline = function SvgEditOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m13.93 2.92 3.15 3.15 1.565-1.566a.786.786 0 0 0 0-1.111l-2.038-2.039a.787.787 0 0 0-1.111 0L13.93 2.92ZM2.875 13.975l3.149 3.15L16.372 6.776l-3.149-3.149L2.875 13.975Zm-.46.955-1.062 3.716 3.717-1.062-2.655-2.654Zm-1.79 4.944a.5.5 0 0 1-.48-.637l1.54-5.39a.495.495 0 0 1 .128-.224l.001-.001L14.789.647a1.788 1.788 0 0 1 2.525 0l2.038 2.039a1.787 1.787 0 0 1 0 2.525L6.378 18.185h-.001v.001h-.001a.497.497 0 0 1-.223.129l-5.39 1.54a.51.51 0 0 1-.138.02Z",
    clipRule: "evenodd"
  })));
};
export default SvgEditOutline;